@switch (columnName) {
  @case ('profileSummary') {
    @let profiles = element.userProfileData ?? [];
    @let count = profiles.length;
    @let primary = profiles[0];
    @if (count) {
      <div class="profile-summary">
        <span class="profile-summary__count">
          {{ count }}
          {{ (count === 1 ? 'profile' : 'profiles') | translate }}
        </span>
        @if (count === 1 && primary) {
          <span class="profile-summary__name">{{ primary.fullName || '-' }}</span>
          @if (primary.tenantName) {
            <span class="profile-summary__tenant">{{ primary.tenantName }}</span>
          }
        }
      </div>
    } @else {
      <span class="muted-cell">{{ 'noProfiles' | translate }}</span>
    }
  }
  @case ('userUpdatedDate') {
    {{ element.userUpdatedDate | date: dateTimeFormat }}
  }
  @case ('profileDetails') {
    <div class="employment-list">
      @if (element.employmentData?.length) {
        @for (employment of element.employmentData; track employment.tenantId) {
          @let departmentNames = employment.departmentNames ?? [];
          <div class="employment-item">
            <div class="employment-item__fields">
              <div class="employment-item__field">
                <span class="employment-item__label">{{ 'profileFullName' | translate }}:</span>
                <span class="employment-item__value">{{ element.fullName || '-' }}</span>
              </div>
              <div class="employment-item__field">
                <span class="employment-item__label">{{ 'tenant' | translate }}:</span>
                <span class="employment-item__value">{{ employment.tenantName || '-' }}</span>
              </div>
              <div class="employment-item__field">
                <span class="employment-item__label">{{ 'departments' | translate }}:</span>
                <span class="employment-item__value">
                  {{ departmentNames.length ? departmentNames.join(', ') : '-' }}
                </span>
              </div>
              <div class="employment-item__field">
                <span class="employment-item__label">{{ 'updated' | translate }}:</span>
                <span class="employment-item__value">
                  {{ employment.updated ? (employment.updated | date: dateTimeFormat) : '-' }}
                </span>
              </div>
              @if (employment.deleted || employment.isPaused) {
                <div class="employment-item__field">
                  <span class="employment-item__label">{{ 'status' | translate }}:</span>
                  <span class="employment-item__status">
                    @if (employment.deleted) {
                      <app-ui-pill name="deleted"></app-ui-pill>
                    }
                    @if (employment.isPaused) {
                      <app-ui-pill name="paused"></app-ui-pill>
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        }
      } @else {
        <div class="employment-item">
          <div class="employment-item__fields">
            <div class="employment-item__field">
              <span class="employment-item__label">{{ 'profileFullName' | translate }}:</span>
              <span class="employment-item__value">{{ element.fullName || '-' }}</span>
            </div>
            <div class="employment-item__field">
              <span class="employment-item__label">{{ 'profileEmployments' | translate }}:</span>
              <span class="employment-item__value">{{ 'noEmployments' | translate }}</span>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @case ('isPasswordSet') {
    <mat-icon class="material-icons-round">
      {{ element?.accountAccessDetails?.isPasswordSet ? 'check' : 'close' }}
    </mat-icon>
  }
  @case ('lockoutEnd') {
    {{ element?.accountAccessDetails?.lockoutEnd | date: dateTimeFormat }}
  }
  @case ('isActive') {
    @if (element.isActive) {
      <app-ui-button
        appConfirmDialog
        appStopClickPropagation
        buttonType="icon-button"
        icon="check"
        tooltip="{{ 'deactivate' | translate | titlecase }}"
        confirmTitle="deactivate"
        confirmButtonText="deactivate"
        confirmMessage="deactivateUserAccessWarning"
        warningMessage="deactivateUserAccessConfirmation"
        [showAreYouSure]="false"
        [ownPunctuationMark]="true"
        [disabled]="(actions | actionInProgress | async) === true"
        (confirmed)="setActivationStatus()"
      ></app-ui-button>
    } @else {
      <app-ui-button
        buttonType="icon-button"
        icon="close"
        tooltip="{{ 'activate' | translate | titlecase }}"
        [disabled]="(actions | actionInProgress | async) === true"
        (click)="setActivationStatus($event)"
      ></app-ui-button>
    }
  }
  @default {
    @if (showIcon) {
      <ng-container *ngTemplateOutlet="showIconTemplate"></ng-container>
    } @else {
      {{ element[columnName] }}
    }
  }
}
<ng-template #showIconTemplate class="mat-icon-container">
  <mat-icon class="material-icons-round">{{ element[columnName] ? 'check' : 'close' }}</mat-icon>
</ng-template>
